<template>
  <div :class="$style.iconItem">
    <Badge
      v-if="hasBadge"
      :class="$style.badge"
      offset-y="6"
      offset-x="5"
      bordered
      dot
    >
      <v-icon
        v-if="isIconNameOrSvg"
        :class="iconColor"
      >
        {{ icon }}
      </v-icon>
      <component
        v-else
        :class="iconColor"
        :is="icon"
      />
    </Badge>
    <template v-else>
      <v-icon
        v-if="isIconNameOrSvg"
        :class="iconColor"
      >
        {{ icon }}
      </v-icon>
      <component
        v-else
        :class="iconColor"
        :is="icon"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Badge } from '../global/badge';

@Component({
  components: {
    Badge,
  },
})
export default class SidebarItem extends Vue {
  @Prop({
    type: [
      String, Object,
    ],
    default: '',
  })
  icon!: string;

  @Prop({ type: Boolean, default: false })
  hasBadge!: boolean;

  @Prop({ type: Boolean, default: false })
  isActive!: boolean;

  get isIconNameOrSvg() {
    return typeof this.icon === 'string';
  }

  get iconColor() {
    return this.isActive ? 'error--text text--darken-4' : 'primary--text text--darken-3';
  }
}
</script>

<style module lang="scss">
.iconItem {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.badge {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
